module.exports = __webpack_public_path__ + "static/media/log-out.bfbb6ae5.svg";